const QuizRentersIcon = ({ width }: { width?: number }) => (
  <svg
    width={`${width || 33}`}
    height={`${width || 32}`}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.9777 6.38518C28.8869 6.29065 28.7775 6.21586 28.6563 6.16552C28.5351 6.11519 28.4048 6.09039 28.2735 6.09268C21.3868 6.13772 18.1145 3.44144 17.03 2.28021C16.9314 2.17492 16.8128 2.09038 16.6809 2.0316C16.5491 1.97282 16.4067 1.94099 16.2623 1.93799C16.1225 1.93362 15.9834 1.95877 15.854 2.0118C15.7247 2.06484 15.608 2.14455 15.5118 2.2457L15.4701 2.28957C14.3856 3.44963 11.1233 6.14006 4.22419 6.10321C3.95996 6.10443 3.70689 6.20954 3.51997 6.39571C3.43032 6.48645 3.36019 6.59448 3.31387 6.71317C3.26756 6.83187 3.24603 6.95874 3.2506 7.08602C3.35037 10.3246 4.43664 26.645 15.993 29.9088C16.016 29.9155 16.0396 29.9202 16.0634 29.9228L16.1861 29.9368C16.2027 29.9377 16.2193 29.9377 16.2359 29.9368C16.2756 29.9365 16.3151 29.931 16.3533 29.9205C24.0434 27.7518 27.1778 19.8403 28.4566 13.586C28.4682 13.5295 28.4684 13.4713 28.4575 13.4148C28.4465 13.3582 28.4244 13.3043 28.3925 13.2562C28.3606 13.2082 28.3196 13.1668 28.2717 13.1346C28.2237 13.1023 28.1699 13.0798 28.1133 13.0683C28.0566 13.0567 27.9983 13.0564 27.9415 13.0674C27.8848 13.0784 27.8307 13.1004 27.7825 13.1321C27.6851 13.1963 27.6173 13.2964 27.5939 13.4105C26.3715 19.4027 23.402 26.9691 16.2031 29.0535C5.26586 25.9337 4.22889 10.1859 4.15201 7.00996C4.15823 6.99815 4.16831 6.9888 4.18058 6.98348C4.19286 6.97816 4.20659 6.97719 4.2195 6.98071C11.4636 7.0281 14.9507 4.13292 16.1438 2.85703C16.1578 2.84333 16.1744 2.83259 16.1927 2.82545C16.2109 2.81831 16.2304 2.81492 16.25 2.81549C16.2759 2.81629 16.3014 2.82224 16.325 2.83299C16.3486 2.84374 16.3698 2.85907 16.3873 2.87809C17.5511 4.12356 21.047 7.02284 28.2823 6.97311C28.3216 6.97311 28.341 6.99008 28.3697 7.05033C28.358 7.45047 28.3199 8.29112 28.2025 9.43188C28.1966 9.48915 28.2021 9.54702 28.2186 9.60218C28.2352 9.65734 28.2624 9.70872 28.2989 9.75337C28.3725 9.84355 28.4791 9.90088 28.5951 9.91275C28.6525 9.91863 28.7106 9.91317 28.7659 9.89668C28.8213 9.88019 28.8728 9.853 28.9176 9.81666C29.0081 9.74326 29.0656 9.63705 29.0775 9.52138C29.199 8.35138 29.2371 7.4885 29.2494 7.07665C29.2539 6.94902 29.232 6.82182 29.1853 6.70291C29.1386 6.58399 29.0679 6.47586 28.9777 6.38518Z"
      fill="#008254"
    />
    <path
      d="M12.1665 20.5018H20.1516C20.4277 20.5018 20.6516 20.2779 20.6516 20.0018V11.3463C20.6516 11.0702 20.4277 10.8463 20.1516 10.8463H12.6665C12.3904 10.8463 12.1665 11.0702 12.1665 11.3463V20.4375"
      stroke="#008254"
      stroke-linecap="round"
    />
    <path
      d="M15.0923 20.5018V18.0759C15.0923 17.7998 15.3161 17.5759 15.5923 17.5759H17.2256C17.5017 17.5759 17.7256 17.7998 17.7256 18.0759V20.5018"
      stroke="#008254"
    />
    <rect
      x="13.9219"
      y="12.6018"
      width="1.75554"
      height="2.9259"
      rx="0.5"
      stroke="#008254"
    />
    <rect
      x="17.4331"
      y="12.6018"
      width="1.75554"
      height="2.9259"
      rx="0.5"
      stroke="#008254"
    />
  </svg>
);

export default QuizRentersIcon;
